export const FEEDBACK_PRICING = {
  1: {
    price: 19000,
    salePrice: 9900,
    label: "문서형 피드백 (PDF)",
    description: "상세 분석 리포트",
  },
  2: {
    price: 23900,
    salePrice: 15900,
    label: "음성·영상형 피드백",
    description: "전문가 음성 피드백",
  },
  3: {
    price: 38000,
    salePrice: 23900,
    label: "실시간 1:1 피드백",
    description: "표정, 제스처까지 짚어주는 실시간 1:1 피드백",
  },
} as const;

export type FeedbackOptionId = keyof typeof FEEDBACK_PRICING;

export function formatWon(amount: number): string {
  return `₩${amount.toLocaleString()}`;
}
